package br.com.vvrefeicoes.portal.domain.model

enum class ComplaintStatus {
    OPEN,
    IN_PROGRESS,
    RESOLVED,
    CLOSED,
}

data class CustomerComplaint(
    val id: String,
    val date: String,
    val time: String,
    val directorate: String,
    val managerName: String,
    val restaurant: String,
    val service: String,
    val status: ComplaintStatus,
    val supplier: String,
    val shift: String,
    val nature: String,
    val description: String,
    val treatment: String,
    val treatmentOwner: String,
    val unidadeId: String = "",
)
